import { ChangeEvent } from 'react'

type SelectProps = {
  name: string
  choices: string[]
  includeBlank?: boolean
  required?: boolean
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void
  value?: string
}

export const Select = ({
  name,
  choices,
  includeBlank,
  onChange,
  required,
}: SelectProps) => {
  const options = choices.map((option) => (
    <option key={option} value={option}>
      {option}
    </option>
  ))

  return (
    <select name={name} required={required} onChange={onChange}>
      {includeBlank && <option />}
      {options}
    </select>
  )
}
